import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import TableCell from '@mui/material/TableCell';
import { useBoolean } from 'src/hooks/use-boolean';
import Iconify from 'src/components/iconify';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import { ConfirmDialog } from 'src/components/custom-dialog';
import { dateformation } from 'src/components/date-format-mdy';
import { formatCurrency } from '../../risk-register/feching';
// ----------------------------------------------------------------------

export default function UserTableRow({
  row,
  selected,
  onEditRow,
  onSelectRow,
  onDeleteRow,
  serialNumber,
}) {
  const {
    date,
    date_of_receipt,
    debit,
    credit,
    bank_information,
    invoice_date,
    balance,
    notes,
    description,
    purchase_order_number,
    subcontractor_agreement_id,
    work_order_po_id,
    import_from,
    account_chart,
    entry_type,
  } = row;

  const getSourceLabel = () => {
    if (purchase_order_number) return 'Purchase Order';
    if (subcontractor_agreement_id) return 'Subcontractor Agreement';
    if (work_order_po_id) return 'Work Order';
    if (entry_type === 'expense') return 'Expense';
    if (entry_type === 'income') return 'Income';
    if (import_from) return 'Account Receivable';

    return '';
  };
  const confirm = useBoolean();
  const popover = usePopover();
  return (
    <>
      <TableRow hover selected={selected}>
        <TableCell padding="checkbox">
          <Checkbox checked={selected} onClick={onSelectRow} />
        </TableCell>
        <TableCell sx={{ whiteSpace: 'nowrap' }}>{serialNumber}</TableCell>
        <TableCell sx={{ whiteSpace: 'nowrap' }}>
          {dateformation(date_of_receipt) || dateformation(date) || dateformation(invoice_date)}
        </TableCell>
        <TableCell sx={{ whiteSpace: 'nowrap' }}>{bank_information?.bank_name}</TableCell>
        <TableCell sx={{ whiteSpace: 'nowrap' }}>{account_chart?.account_type?.name}</TableCell>
        <TableCell sx={{ whiteSpace: 'nowrap' }}>{getSourceLabel()}</TableCell>
        <TableCell sx={{ whiteSpace: 'nowrap' }}>{description || notes}</TableCell>
        <TableCell sx={{ whiteSpace: 'nowrap' }}>{formatCurrency(debit || 0)}</TableCell>
        <TableCell sx={{ whiteSpace: 'nowrap' }}>{formatCurrency(credit || 0)}</TableCell>
        <TableCell sx={{ whiteSpace: 'nowrap' }}>{formatCurrency(balance)}</TableCell>
      </TableRow>
      <CustomPopover
        open={popover.open}
        onClose={popover.onClose}
        arrow="right-top"
        sx={{ width: 140 }}
      >
        <MenuItem
          onClick={() => {
            confirm.onTrue();
            popover.onClose();
          }}
          sx={{ color: 'error.main' }}
        >
          <Iconify icon="solar:trash-bin-trash-bold" />
          Delete
        </MenuItem>
        <MenuItem
          onClick={() => {
            onEditRow();
            popover.onClose();
          }}
        >
          <Iconify icon="solar:pen-bold" />
          Edit
        </MenuItem>
      </CustomPopover>
      <ConfirmDialog
        open={confirm.value}
        onClose={confirm.onFalse}
        title="Delete"
        content="Are you sure want to delete?"
        action={
          <Button variant="contained" color="error" onClick={onDeleteRow}>
            Delete
          </Button>
        }
      />
    </>
  );
}
UserTableRow.propTypes = {
  onDeleteRow: PropTypes.func,
  onEditRow: PropTypes.func,
  onSelectRow: PropTypes.func,
  row: PropTypes.object,
  selected: PropTypes.bool,
};
